import { isNil } from 'lodash';

import { CallList, EntityStatsChunk, formatDuration } from '@pwp-common';

import { createReportRow } from '../create-report-row/create-report-row';
import { createValuesForEntityStats } from '../create-values-for-entity-stats/create-values-for-entity-stats';
import { AdminReportCallStatsRowInput, ReportRow } from '../interfaces';

const getFormattedDuration = (statsChunk: EntityStatsChunk, callList: CallList): string => {
  const talkTime = statsChunk.getCalls(callList)?.avgTalkTimeMS();

  return isNil(talkTime) ? undefined : formatDuration(talkTime);
};

export const createAverageTalkDurationRow = ({ entityStats, callList }: AdminReportCallStatsRowInput): ReportRow =>
  createReportRow(
    'averageTalkDuration',
    createValuesForEntityStats(entityStats, (statsChunk) => getFormattedDuration(statsChunk, callList)),
    { callList },
  );
